import { MobileMenuProps } from './types';
import { MenuItem } from '../molecules';

export const MobileMenu = ({ isLandscape, menuItems }: MobileMenuProps) => {
    return (
        <nav
            data-testid="mobileMenu"
            id="mobileMenu"
            className={`${isLandscape ? 'col-start-2 row-start-1 flex' : 'col-start-1 row-start-3'} bg-white shadow-menu z-30`}
        >
            <ul className={`flex ${isLandscape ? 'w-full flex-col my-auto' : 'h-16 max-w-[520px] mx-auto'}`}>
                {(menuItems || []).map((element) => (
                    <MenuItem key={element.componentType} {...element} />
                ))}
            </ul>
        </nav>
    );
};
